module.exports = __webpack_public_path__ + "static/media/clipboard-list-check.2c83536d.svg";